export default __webpack_public_path__ + "static/char-v-34-3384ddfad5a99243b154ab5894b36a32.png";